import React,{useEffect} from 'react';
import { Link, useNavigate } from 'react-router-dom';
const SuccessPage = () => {
    // Insert keyframes for spinning animation
    const styleSheet = document.styleSheets[0];
    const keyframes = `
    @keyframes spin {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }
  `;
    styleSheet.insertRule(keyframes, styleSheet.cssRules.length);

    const pageStyle = {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        backgroundColor: '#f5f5f5',
        fontFamily: 'Arial, sans-serif',
        textAlign: 'center',
        flexDirection: 'column',

    };

    const containerStyle = {
        position: 'relative',
        width: '200px',
        height: '200px',
    };

    const circleStyle = {
        position: 'absolute',
        width: '100%',
        height: '100%',
        borderRadius: '50%',
        border: '10px solid #4caf50',
        borderTop: '10px solid transparent',
        animation: 'spin 1s linear',
    };

    const checkmarkStyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        fontSize: '60px',
        color: '#4caf50',
        lineHeight: '0',
    };

   const messageStyle = {
        marginTop: '20px', // Space between the circle and message
        fontSize: '20px',
       color: '#4caf50',
      
    };

    const navigate = useNavigate();

    useEffect(() => {
        setTimeout(() => {
            // navigate('/');
            navigate('/orders');
        },2000)
    }, [])


    return (
        <div style={pageStyle}>
            <div style={containerStyle}>
                <div style={circleStyle}></div>
                <div style={checkmarkStyle}>✓</div>
            </div>
            <p style={messageStyle}>Order Placed Successfully!</p>
        </div>
    );
}

export default SuccessPage;
